var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"font-weight-bold font-size-14 cursor-pointer",on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._v(" "+_vm._s(_vm.formatStudentFullName(_vm.student))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }